import { useCallback } from 'react';

const useFilterFields = (filters, setFilters) => {
    const setFilterFields = useCallback(
        (names: string[], values: any[]) => {
            const changedFields = {};
            names.forEach((name, index) => (changedFields[name] = values[index]));
            setFilters({ ...filters, ...changedFields });
        },
        [filters, setFilters]
    );
    return { setFilterFields };
};

export default useFilterFields;
